import { createReducer, on, Action } from '@ngrx/store';
import { IEMRLayout } from '@care-portals/api-interfaces';
import * as AppActions from './app.actions';

export const APP_FEATURE_KEY = 'app';

export interface State {
  layouts: IEMRLayout[];
  selectedLayoutIndex: number;
  loading: boolean;
  error: any;
}

export interface AppPartialState {
  readonly [APP_FEATURE_KEY]: State;
}

export const initialState: State = {
  layouts: [],
  selectedLayoutIndex: null,
  loading: false,
  error: null
};

const appReducer = createReducer(
  initialState,
  on(AppActions.loadAppLayouts, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(AppActions.loadAppLayoutsSuccess, (state, { appLayouts }) => ({
    ...state,
    loading: appLayouts?.length > 0 ? true : false, // only set to false when layout is selected
    layouts: appLayouts || [],
    error: null
  })),
  on(AppActions.loadAppLayoutsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    selectedLayoutIndex: null
  })),

  /* ------------------------------ select brand ------------------------------ */
  on(AppActions.setActiveLayout, (state, { activeLayoutIndex }) => {
    return {
      ...state,
      loading: false,
      selectedLayoutIndex: activeLayoutIndex
    };
  })
);

export function reducer(state: State | undefined, action: Action) {
  return appReducer(state, action);
}
